<template>
  <b-row class="mb-2">
    <b-col>
      <h3 v-if="title">
        {{ title }}
        <slot></slot>
      </h3>
    </b-col>
  </b-row>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: undefined
    }
  }
};
</script>
